<input type="checkbox" id="findHighlightAll" class="toolbarField" />
<label for="findHighlightAll" class="toolbarLabel" data-l10n-id="pdfjs-find-highlight-checkbox"> Highlight all </label>
